
import React, { ErrorInfo, ReactNode } from 'react';
import { monitoring } from '../services/monitoring';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    // Phase 12: Capture exception in monitoring service
    monitoring.captureException(error, { componentStack: errorInfo.componentStack });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-app-bg p-4 text-center">
          <div className="max-w-md bg-card-bg p-8 rounded-2xl shadow-xl border border-card-border">
            <div className="text-6xl mb-4">🚜</div>
            <h1 className="text-2xl font-bold text-card-title mb-2">Oops! Something went wrong.</h1>
            <p className="text-app-text-secondary mb-6">
              The farm tractor hit a bump. We've logged the error and our engineers are on it.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-btn-primary text-btn-primary-text px-6 py-3 rounded-full font-bold hover:bg-btn-primary-hover transition-all transform active:scale-95 shadow-lg"
            >
              Back to Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
